import {
  Selectors,
  getState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {all, put, takeLatest} from '@redux-saga/core/effects';
import {Platform} from 'react-native';
import {call} from 'redux-saga/effects';

import {
  GetReservationsConfig,
  getReservations,
} from 'services/api/reservations/reservations';
import {ReservationsActions} from 'store/reservations/reservations.reducer';

export const CACHE_TTL_MINS = 30;

export function* handleGetReservations() {
  let primaryaccttoken;
  if (Platform.OS === 'web') {
    primaryaccttoken = yield call(getState, Selectors.sectokenSelector);
  } else {
    // Native request
    primaryaccttoken = yield call(getState, Selectors.patrontokenSelector);
  }

  const config: GetReservationsConfig = {
    primaryaccttoken,
  };
  try {
    const response = yield call(getReservations, config);

    if (
      response.data?.length &&
      response.data?.length > 0 &&
      response.data[0]?.['@messageType'] === 'FAILURE'
    ) {
      yield put(ReservationsActions.getReservationsFailed());
    } else {
      yield put(ReservationsActions.getReservationsSuccess(response.data));
    }
  } catch (err) {
    yield put(ReservationsActions.getReservationsFailed());
  }
}

export default function* reservationsSagas() {
  yield all([
    takeLatest(ReservationsActions.getReservations, handleGetReservations),
  ]);
}
